export default __webpack_public_path__ + "static/media/modalperson.17c6960c.svg";